<!-- 车牌校正数据上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportModifyCar",
                "inDate": "20190801081411",
                "lockKey": "3d1872eb2425bbe7c7f8886a5d0822d711937258",
                "modifyBy": "09977",
                "modifyDate": "20190801081904",
                "newCarCode": "粤BDD9296",
                "parkCode": "2KM8T26T",
                "parkingCode": "190801081411737104392296"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场车牌校正数据到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportModifyCar",
                precondition: "无",
                fitSystem: "智泊云，VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水' },
                        { info1: 'newCarCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'newCardCode', info2: '否', info3: 'String', info4: '卡号' },
                        { info1: 'inDate', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'modifyBy', info2: '是', info3: 'String', info4: '校正人' },
                        { info1: 'modifyDate', info2: '是', info3: 'String', info4: '校正时间，yyyyMMddHHmmss' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'carType', info2: '否', info3: 'Integer', info4: '车辆类型' },
                        { info1: 'carLicenseColor', info2: '否', info3: 'Integer', info4: '车辆颜色' },
                        { info1: 'oldCarCode', info2: '否', info3: 'String', info4: '校正前车牌' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportModifyCar.vue